import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';
import { withEnvGuard } from '@traton/devportal-env-kit-app';

import { rootRouteRef } from './routes';

export const agenticMarketplacePlugin = createPlugin({
  id: 'agentic-marketplace',
  routes: {
    root: rootRouteRef,
  },
});

export const AgenticMarketplacePage = agenticMarketplacePlugin.provide(
  createRoutableExtension({
    name: 'AgenticMarketplacePage',
    component: () =>
      import('./components/AgenticMarketplacePage').then(m =>
        withEnvGuard(m.AgenticMarketplacePage, 'agentic-marketplace'),
      ),
    mountPoint: rootRouteRef,
  }),
);
